var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPacked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_900_1517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2349 21.5802L17 26.252V33L29.2349 27.8092V21.5802Z",
    fill: "#FCA66C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1504 9L6.15039 10.5238M6.15039 10.5238L1.15039 16.2381L4.48372 17.8067M6.15039 10.5238L16.8171 16.2381M16.8171 16.2381L12.4837 21.5714L4.48372 17.8067M16.8171 16.2381L21.1504 20.8095L29.1504 16.746M16.8171 16.2381L28.4837 10.5238M16.8171 16.2381V33M28.4837 10.5238L33.1504 14.7143L29.1504 16.746M28.4837 10.5238L23.4837 9M16.8171 33L29.1504 27.6667V16.746M16.8171 33L4.48372 27.6667V17.8067",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.15039 1H12.427C15.1884 1 17.427 3.23858 17.427 6V11M17.427 11L20.1504 8.32439M17.427 11L14.0227 8.32439",
    stroke: "#383434",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_900_1517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPacked);
export default __webpack_public_path__ + "static/media/Packed.9c545ffa88dd576e58f36a60f0c10629.svg";
export { ForwardRef as ReactComponent };